/** constants */
export const TRUSTED_URLS_TO_REDIRECT = [
  '/meus-pedidos',
  '/meus-ingressos',
  '/minha-conta',
  '/sympla-play',
  '/online',
  'organizador.sympla.com.br',
];

const verifyTrustedUrlsToRedirect = (urlToRedirect: string) => {
  if (!urlToRedirect) return;

  if (typeof urlToRedirect !== 'string') throw new Error('Missing parameter or invalid type');

  const _check = (url: string) => urlToRedirect.startsWith(url) || (urlToRedirect.startsWith('/') && !urlToRedirect.startsWith('//'));

  if (TRUSTED_URLS_TO_REDIRECT.some(_check)) {
    window.location.href = urlToRedirect;
  }
};

export default verifyTrustedUrlsToRedirect;
